const C = "CATERING.EDIT"

export const RETRIEVE_CATERING = `${C}.RETRIEVE_CATERING`
export const RETRIEVE_CATERING_COMPLETED = `${C}.RETRIEVE_CATERING_COMPLETED`
export const RETRIEVE_CATERING_FAILED = `${C}.RETRIEVE_CATERING_FAILED`

export const SUBMIT = `${C}.SUBMIT`
export const SUBMIT_COMPLETED = `${C}.SUBMIT_COMPLETED`
export const SUBMIT_FAILED = `${C}.SUBMIT_FAILED`
